<template>
  <div v-if="scaleFeeType">
    <h1>Scale fee type</h1>
    <v-btn :to="{ name: 'scaleTypes' }">
      <v-icon>chevron_left</v-icon>Scale types
    </v-btn>
    <h3>Scale fee type details</h3>
    <v-form>
      <v-text-field label="Id" v-model="scaleFeeType.id" outline readonly />
      <v-text-field label="Name" v-model="scaleFeeType.name" outline />
      <v-text-field
        label="Description"
        v-model="scaleFeeType.description"
        outline
      />
      <v-checkbox
        label="Exclude from promotions"
        v-model="scaleFeeType.exclude"
      />
      <v-btn @click="saveScaleFeeType"> <v-icon>save</v-icon>Save </v-btn>
    </v-form>
    <div v-if="computedEditing">
      <h3>Scale fees</h3>
      <v-data-table
        :pagination.sync="pagination"
        :headers="headers"
        :items="scaleFees"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <v-btn
                :to="{ name: 'scaleFee', params: { id: props.item.id } }"
                small
                >{{ props.item.id }}</v-btn
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "ScaleFeeType",
  metaInfo() {
    return {
      title: "Scale fee type",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedEditing() {
      return this.$route.params.id ? true : false;
    }
  },
  data() {
    return {
      scaleFeeType: null,
      scaleFees: [],
      headers: [
        {
          text: "Id",
          value: "id"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "name",
        descending: false
      }
    };
  },
  methods: {
    async fetchScaleFeeType() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/scaleFeeTypes/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.scaleFeeType = response.data;
    },
    async fetchScaleFees() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/scaleFeeTypes/${this.$route.params.id}/scaleFees`
      );

      // console.log(response.data);
      this.scaleFees = response.data;
    },
    saveScaleFeeType() {
      if (this.$route.params.id) {
        this.updateScaleFeeType();
      } else {
        this.createScaleFeeType();
      }
    },
    async createScaleFeeType() {
      await nbmlaw.post(`/cors/admin/sales/scaleFeeTypes`, this.scaleFeeType);
      // console.log(response.data);
      this.$router.push({ name: "scaleTypes" });
    },
    async updateScaleFeeType() {
      await nbmlaw.put(
        `/cors/admin/sales/scaleFeeTypes/${this.$route.params.id}`,
        this.scaleFeeType
      );
      // console.log(response.data);
      this.$router.push({ name: "scaleTypes" });
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchScaleFeeType();
          this.fetchScaleFees();
        } else {
          this.scaleFeeType = {};
          this.scaleFees = [];
        }
      }
    }
  }
};
</script>